import { useEffect, useState } from "react";
import "./Landing.css";
import sv from "../assests/single.jpg";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../redux/slices/cartSlice";
import { addtocart } from "../apis/Cart";
import { MdShoppingCartCheckout } from "react-icons/md";
import { FaHeart } from "react-icons/fa";
import { CgRemove } from "react-icons/cg";
import { UserCircle2 } from "lucide-react";

const Landing = ({
  products,
  wishlist,
  fetchbag,
  bag,
  updateQuantity,
  remove,
  StorageUserData,
}) => {
  const [loadingProductId, setLoadingProductId] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  const showRelatedProduct = (id) => {
    const excatproduct = products.find((p) => p.product_id === id);
    navigate(`/productview/${encodeURIComponent(id)}`, {
      state: { product: excatproduct },
    });
  };

  const dispatch = useDispatch();

  const handleAddToCart = async (product, type, price, size) => {
    if (loadingProductId === product.id) return;

    setLoadingProductId(product.id);

    try {
      await addtocart(product, type, fetchbag, price, size);
      dispatch(addToCart(product));
    } catch (error) {
      console.error("Failed to add to cart:", error);
    } finally {
      setLoadingProductId(null);
    }
  };

  const handleremove = async (option, id) => {
    if (loadingProductId === id) return;

    setLoadingProductId(id);
    try {
      await remove(option, id, "wishlist");
    } catch (error) {
      console.error("Failed to remove from wishlist:", error);
    } finally {
      setLoadingProductId(null);
    }
  };

  const { state } = useLocation();
  const results = state?.results || [];
  const query = state?.query || "";

  const isSearchPage = location.pathname === "/search";

  const itemsToRender = isSearchPage ? results : products;

  const Slider = `${process.env.REACT_APP_BASEURL}/apis/slider/slider.png`
  const Slider1 = `${process.env.REACT_APP_BASEURL}/apis/slider/slider.jpeg`



  const [userData, setUserData] = useState(StorageUserData);

  useEffect(() => {
    setUserData(StorageUserData);
  }, [userData])

  return (
    <div style={{ background: "#f1f3f6" }}>
      {location.pathname === "/" && (
        <div className="hero-image">
          <img src={Slider || Slider1}
            alt="Fashion Model"
            onError={(e) => (e.target.src = Slider1)}
            style={{
              width: "100%",
              height: "650px",
              objectFit: "cover", // or "cover"
              borderRadius: "8px",
              objectPosition: "top"
            }}
          />
        </div>
      )}

      <main className="lp-main">
        {/* Sidebar Filter */}
        {/* <aside className="lp-sidebar">
          <h3>Filter by Category</h3>
          <ul className="lp-filter-list">
            {categories.map((cat) => (
              <li
                key={cat}
                className={selectedCategory === cat ? "active" : ""}
                onClick={() => setSelectedCategory(cat)}
              >
                {cat}
              </li>
            ))}
          </ul>

          <h3>Filter by Brand</h3>
          <ul className="lp-filter-list">
            {brands.map((brand) => (
              <li
                key={brand}
                className={selectedBrand === brand ? "active" : ""}
                onClick={() => setSelectedBrand(brand)}
              >
                {brand}
              </li>
            ))}
          </ul>

          <h3>Price Range</h3>
          <div className="lp-price-range-slider">
            <span>Min</span>
            <input
              type="range"
              min="0"
              max="10000"
              step="100"
              value={minPrice}
              onChange={(e) => setMinPrice(Number(e.target.value))}
            />
            <span>Max</span>
            <input
              type="range"
              min="0"
              max="10000"
              step="100"
              value={maxPrice}
              onChange={(e) => setMaxPrice(Number(e.target.value))}
            />
            <div className="lp-price-values">
              <span>₹{minPrice}</span>
              <span>to</span>
              <span>₹{maxPrice}</span>
            </div>
          </div>
        </aside> */}

        {/* Product Section */}
        <section className="lp-products-section">
          <h2>
            {
              location.pathname === "/search" ?
                "Results Found" : "Our Products"
            }
          </h2>

          <div className="lp-product-grid">
            {itemsToRender.map((product) => (
              <div
                key={product.id}
                className="lp-product-card"
                onClick={() => showRelatedProduct(product?.product_id)}
              >

                {userData?.islogin === true &&
                  (Array.isArray(wishlist) &&
                    wishlist.some(
                      (item) => String(item.product_id) === String(product?.id)
                    ) ? (
                    wishlist
                      .filter(
                        (item) => String(item.product_id) === String(product?.id)
                      )
                      .map((item) => (
                        <div className="quantity-controls" key={item.id}>
                          <button
                            className="wishlist-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleremove("delete", item?.id);
                            }}
                          >
                            <CgRemove />
                          </button>
                        </div>
                      ))
                  ) : (
                    <button
                      className="wishlist-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAddToCart(product?.id, "wishlist");
                      }}
                    >
                      {loadingProductId === product.id ? (
                        "Adding..."
                      ) : (
                        <FaHeart />
                      )}
                    </button>
                  ))}
                <img
                  src={`${process.env.REACT_APP_BASEURL
                    }/apis/vendor/uploads/products/${product.prod_img.split(",")[0]
                    }`}
                  alt={product.name}
                />
                <div
                  style={{
                    margin: "10px 0",
                    fontSize: "12px",
                  }} >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    <h3 style={{ color: "#337ad8" }}>{product?.prod_name}</h3>

                    {userData?.islogin === true && (
                      <p className="lp-price">
                        ₹
                        {Math.min(
                          ...product?.prod_details.map(
                            (item) => item.discounted_amount ?? item.prod_price
                          )
                        )}
                      </p>
                    )}
                  </div>


                  <span>{product?.prod_desc}</span>
                </div>

                {userData?.islogin === true && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                    }}
                  >
                    {Array.isArray(bag) &&
                      bag.some(
                        (item) =>
                          String(item.product_id) === String(product?.id) &&
                          item.prod_size === product?.prod_details?.[0]?.prod_size
                      ) ? (
                      bag
                        .filter(
                          (item) =>
                            String(item.product_id) === String(product?.id) &&
                            item.prod_size === product?.prod_details?.[0]?.prod_size
                        )
                        .map((item) => (
                          <div className="quantity-controls" key={item.id}>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                updateQuantity(item.id, -1, "cart");
                              }}
                            >
                              -
                            </button>
                            <span>{item.quantity}</span>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                updateQuantity(item.id, 1, "cart");
                              }}
                            >
                              +
                            </button>
                          </div>
                        ))
                    ) : product?.prod_details?.[0]?.stock > 0 ? (
                      <button
                        className="lp-buy-btn"
                        onClick={(e) => {
                          e.stopPropagation();

                          const actualPrice =
                            product?.prod_details?.[0]?.discounted_amount ??
                            product?.prod_details?.[0]?.prod_price;

                          handleAddToCart(
                            product?.id,
                            "cart",
                            actualPrice,
                            product?.prod_details?.[0]?.prod_size
                          );
                        }}
                      >
                        <span>
                          <MdShoppingCartCheckout />
                        </span>
                        {loadingProductId === product.id ? "Adding..." : "Add to Cart"}
                      </button>
                    ) : (
                      <button className="lp-buy-btn out-of-stock" disabled>
                        Unavailable Stock
                      </button>
                    )}
                  </div>
                )}

              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default Landing;
